const parts = [
  process.env.VUE_APP_VISIT_ADDRESS,
  process.env.VUE_APP_VISIT_API_PATH,
  process.env.VUE_APP_VISIT_API_VERSION,
  process.env.VUE_APP_VISIT_PATH
]

export const VISIT_URL = parts.join('/')
